import { render, staticRenderFns } from "./CoursewareCommentsOverviewWidgetFilterCreated.vue?vue&type=template&id=e9800796&"
import script from "./CoursewareCommentsOverviewWidgetFilterCreated.vue?vue&type=script&lang=js&"
export * from "./CoursewareCommentsOverviewWidgetFilterCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports